import { useEffect, Component } from "react";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Sintomas from "@/components/site/Sintomas";
import Sobre from "@/components/site/Sobre";
import Diferencial from "@/components/site/Diferencial";
import ComoFunciona from "@/components/site/ComoFunciona";
import QuandoProcurar from "@/components/site/QuandoProcurar";
import Depoimentos from "@/components/site/Depoimentos";
import CTA from "@/components/site/CTA";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";
import FloatingWhats from "@/components/site/FloatingWhats";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center bg-olive text-cream p-8 text-center">
          <p className="font-display text-2xl">Algo saiu do trilho. Recarregue a página.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="grain bg-cream font-body text-olive antialiased">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Sintomas />
          <Sobre />
          <Diferencial />
          <ComoFunciona />
          <QuandoProcurar />
          <Depoimentos />
          <CTA />
          <FAQ />
        </main>
        <Footer />
        <FloatingWhats />
      </div>
    </ErrorBoundary>
  );
}

export default App;
